// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7723 ? "aa8f2d70" : chunkId) + "." + {"7656":"d888fa07add74f46","7723":"93928e8792ebe55a","8664":"55f4bd5790236811"}[chunkId] + ".js";
};